import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class Reasons extends Component {
    constructor() {
        super()
        this.state = {
            ReasonsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getReasonsListData(this.props.type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getReasonsListData = (type) => {
        apiService.getReasonsListData(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            ReasonsList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from costCenter list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.ReasonsList).map((value,index) => {
            return {
                label : this.state.ReasonsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Reason"
                onChange={(e) => { (e) ? this.props.reasonChange(e,this.props.dataId) : this.props.reasonChange([],this.props.dataId)}}
                />
            </div>
        )
    }
}

export default Reasons


// WEBPACK FOOTER //
// ./src/common/DropDowns/Reasons.js